<template>
  <v-app-bar
    app
    flat
    color="white"
    height="64"
    class="app-navbar">
    <v-app-bar-nav-icon
      class="hidden-lg-and-up"
      @click="openDrawer" />
    <global-search />
    <v-spacer />
    <div class="app-navbar__crumbs">
      <span
        v-if="page.section"
        class="app-navbar__section">{{ page.section }}</span>
      <v-icon
        v-if="page.section"
        size="16"
        color="#a1a1aa">
        mdi-chevron-right
      </v-icon>
      <span class="app-navbar__title">{{ page.title }}</span>
    </div>
  </v-app-bar>
</template>

<script>
  import sections, { routeTitle } from '../navItems'
  import GlobalSearch from './GlobalSearch'

  export default {
    name: 'AppNavbar',
    components: { GlobalSearch },
    computed: {
      page () {
        return routeTitle(sections, this.$route.name)
      }
    },
    methods: {
      openDrawer () {
        this.$store.commit('setDrawer', !this.$store.state.drawer)
      }
    }
  }
</script>

<style scoped>
  .app-navbar >>> .v-toolbar__content {
    padding: 0 32px;
    gap: 12px;
  }
  .app-navbar__crumbs {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    white-space: nowrap;
  }
  .app-navbar__section {
    color: #7a7a85;
  }
  .app-navbar__title {
    font-weight: 700;
  }
  @media (max-width: 900px) {
    .app-navbar__crumbs {
      display: none;
    }
  }
</style>
